<template>
  <div>
    <form-errors :errors="formErrors" />
    <div class="tdesk-form">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <span style="font-weight: 600;">
              You are registering {{ numberOfEnrolsToPurchase }} {{ enrolmentsPluralized }} into {{ courseTitle }} at no cost.
            </span>
          </div>
        </div>
      </div>
    </div>

    <button
      id="complete"
      class="tdesk-primary-button"
      @click="handleCompleteAtNoCost"
    >
      <i class="fas fa-check-circle" />
      Complete
    </button>
  </div>
</template>

<script>
import FormErrors from "../../../components/form_errors.vue";

export default {
  components: { FormErrors },
  props: {
    participants: { type: Array, required: true },
    courseTitle: { type: String, required: true },
    courseId: { type: Number, required: true },
    isPartnerCourse: { type: Boolean, required: true },
    partnerId: { type: Number, required: false, default: null },
    organizer: { type: Object, required: true },
  },
  data() {
    return {
      formErrors: [],
    };
  },
  computed: {
    numberOfEnrolsToPurchase() {
      return this.participants.length;
    },
    enrolmentsPluralized() {
      return this.numberOfEnrolsToPurchase > 1 ? 'enrolments' : 'enrolment';
    },
    freeEnrolCreatePath() {
      if (this.isPartnerCourse) {
        return Routes.partner_lms_course_signup_multi_user_index_path({
          lms_course_id: this.courseId,
          user_information: this.participants,
          organizer_information: this.organizer,
          partnership_id: this.partnerId,
        });
      } else {
        return Routes.signup_lms_course_multi_user_index_path({
          lms_course_id: this.courseId,
          user_information: this.participants,
          organizer_information: this.organizer,
        });
      }
    },
  },
  methods: {
    handleCompleteAtNoCost() {
      $.ajax({
        url: this.freeEnrolCreatePath,
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        success: function() {
          this.$emit('paymentComplete');
        }.bind(this),
        error: function() {
          this.formErrors = ['An error occurred. Please try again or contact support if this issue persists'];
        }.bind(this),
      });
    },
  },
};
</script>
